<!-- @format -->

<ng-container *transloco="let t">
  <div class="container sis-pt-md">
    <sis-breadcrumbs></sis-breadcrumbs>
    <sis-page-title [title]="t('STUDENT_MESSAGES.MESSAGE_CONVERSATIONS_LIST_VIEW.TITLE')" [showCrumbs]="true" />
    <div class="row">
      <div class="col-12">
        <div class="d-flex flex-wrap sis-pb-sm">
          <sis-checkbox
            class="sis-pr-lg"
            data-cy="message-conversations-unread-filter"
            [checked]="isUnreadMessagesSelected"
            (checkedChange)="filterUnreadMessages($event)"
            [label]="t('STUDENT_MESSAGES.MESSAGE_CONVERSATIONS_LIST_VIEW.CHECKBOX_UNREAD_FILTER')">
          </sis-checkbox>
          <sis-checkbox
            data-cy="message-conversations-archived-filter"
            [checked]="isArchivedMessagesSelected"
            (checkedChange)="filterArchivedMessages($event)"
            [label]="t('STUDENT_MESSAGES.MESSAGE_CONVERSATIONS_LIST_VIEW.CHECKBOX_ARCHIVED_FILTER')">
          </sis-checkbox>
        </div>
        @if (result && result.total > 0) {
          <p class="guidance">
            @if (result && result.total === 1) {
              <span> {{ t("STUDENT_MESSAGES.MESSAGE_CONVERSATIONS_LIST_VIEW.NUMBER_OF_CONVERSATIONS_TOTAL_ONE") }}&nbsp; </span>
            }
            @if (result && result.total > 1) {
              <span>
                {{
                  t("STUDENT_MESSAGES.MESSAGE_CONVERSATIONS_LIST_VIEW.NUMBER_OF_CONVERSATIONS_TOTAL", { conversations: result.total })
                }}&nbsp;
              </span>
            }
            @if (unreadMessagesCount === 1) {
              <span>
                {{ t("STUDENT_MESSAGES.MESSAGE_CONVERSATIONS_LIST_VIEW.NUMBER_OF_CONVERSATIONS_UNREAD_ONE") }}
              </span>
            }
            @if (unreadMessagesCount > 1) {
              <span>
                {{
                  t("STUDENT_MESSAGES.MESSAGE_CONVERSATIONS_LIST_VIEW.NUMBER_OF_CONVERSATIONS_UNREAD_TOTAL", {
                    unreadMessages: unreadMessagesCount,
                  })
                }}
              </span>
            }
          </p>
        }
      </div>
    </div>
    <div class="row">
      <div class="messages-container">
        <div class="results-header row g-0">
          <div class="action-container" data-cy="message-conversations-actions">
            <div class="checkbox-container">
              <sis-checkbox
                data-cy="message-conversations-select-all"
                [checked]="allSelected"
                (checkedChange)="toggleSelectAll()"
                [label]="t('ARIA_LABEL.SELECT_ALL_MESSAGES')" />
            </div>
            <sis-menu-button color="primary" [options]="massActionOptions" [placeLeft]="true"></sis-menu-button>
          </div>
        </div>
        <div class="results-container" data-cy="message-conversations-list">
          <sis-message-conversation-list-item
            [hidden]="!result || result.total === 0"
            [messageConversations]="conversations$ | async"
            (moveToMessageConversationView)="moveToMessageConversation($event)"
            [selectedMessageConversationIds]="selectedMessageConversationIds"
            (toggleConversationSelection)="toggleConversationSelection($event)">
          </sis-message-conversation-list-item>
          @if (totalItems > itemsPerPage) {
            <sis-pagination
              [currentPage]="currentPage"
              (currentPageChange)="onPageChange($event)"
              [totalItems]="totalItems"
              [itemsPerPage]="itemsPerPage">
            </sis-pagination>
          }
        </div>
      </div>
    </div>
  </div>
</ng-container>
